import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { StyledRadioButtons } from '../../../../Components/Generics.styled';
import styled from 'styled-components';
import { StyledButton } from '../../../../Components/Generics.styled';

const DoYouAcceptPhoneContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const DoYouAcceptPhone = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { acceptTelephoneOrders } = { ...teachDavieData };
    const [value, setValue] = useState('');

    useEffect(() => {
        if (acceptTelephoneOrders !== '') {
            setValue(acceptTelephoneOrders);
        }
    }, [acceptTelephoneOrders]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, acceptTelephoneOrders: value }));
        handleNavButtonNext();
    };

    const options = [
        {
            value: 'yes',
            label: 'Yes',
        },
        {
            value: 'no',
            label: 'No',
        },
    ];

    return (
        <DoYouAcceptPhoneContainer>
            <StyledRadioButtons
                label={'Do you accept telephone orders?'}
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                options={options}
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Next</Btn>
            </NavButtonContainer>
        </DoYouAcceptPhoneContainer>
    );
};

DoYouAcceptPhone.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

DoYouAcceptPhone.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default DoYouAcceptPhone;
